/* Zaiare — header que vira barra ao rolar e player dos filmes. */
(function () {
  var header = document.querySelector('[data-zv-sticky]');
  if (!header) return;
  // no Horizon quem rola é o .page-wrapper; o window fica de reserva
  var scroller = document.querySelector('.page-wrapper');
  function y() { return (scroller && scroller.scrollTop) || window.scrollY || 0; }
  function update() { header.classList.toggle('is-scrolled', y() > 10); }
  if (scroller) scroller.addEventListener('scroll', update, { passive: true });
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

(function () {
  // Player dos filmes: um <dialog> por página, preenchido no clique.
  var dialog = document.getElementById('zv-film-dialog');
  if (!dialog) return;
  var player = dialog.querySelector('video');
  var closeBtn = dialog.querySelector('.zv-dialog__close');

  function close() {
    player.pause();
    player.removeAttribute('src');
    player.load();
    if (dialog.open) dialog.close();
  }

  document.querySelectorAll('[data-zv-film]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      player.src = btn.getAttribute('data-zv-film');
      player.setAttribute('aria-label', btn.getAttribute('data-zv-title') || '');
      dialog.showModal();
      player.play();
    });
  });

  closeBtn.addEventListener('click', close);
  dialog.addEventListener('close', close);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });
})();

/* Tracking da página (home): publica eventos para o Custom Pixel da loja, que repassa ao PostHog e ao GA4.
   Nenhum evento leva nome, e-mail ou telefone: só títulos de filmes, posições e rótulos de menu. */
(function () {
  if (window.__zvTrack) return;
  window.__zvTrack = true;

  function send(name, props) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, props || {});
      }
    } catch (e) {}
  }
  window.zvTrack = send;                 // o zaiare-lista-vip.js usa o mesmo canal

  var done = {};                         // cada marco dispara uma vez por visita
  function cut(s, n) { return String(s || '').replace(/\s+/g, ' ').trim().slice(0, n || 80); }

  function formLocation(w) {
    return w.classList.contains('zv-vipf--hero') ? 'hero' : (w.closest('#lista-vip') ? 'bottom' : 'other');
  }

  // Cliques: filmes, menu, rodape e links externos (um listener so, na captura)
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;

    var film = el.closest('.zv-film');
    if (film) {
      var all = [].slice.call(document.querySelectorAll('.zv-film'));
      var title = film.querySelector('.zv-film__meta span');
      send('film_click', {
        film_title: cut(title ? title.textContent : film.getAttribute('data-zv-title')),
        film_position: all.indexOf(film) + 1,
        opens: film.tagName === 'A' ? 'instagram' : 'player'
      });
      return;
    }

    var a = el.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var area = a.closest('.zv-header') ? 'header' : (a.closest('.zv-footer') ? 'footer' : '');
    var external = a.hostname && a.hostname !== location.hostname;

    if (external) {
      send('outbound_click', { destination: cut(a.hostname + a.pathname, 80), area: area || 'page' });
    } else if (area) {
      send('nav_click', { label: cut(a.textContent) || 'logo', destination: cut(href, 80), area: area });
    }
  }, true);

  // Inicio do formulario da lista VIP (primeiro foco em qualquer campo)
  document.addEventListener('focusin', function (e) {
    var w = e.target && e.target.closest ? e.target.closest('.zv-vipf') : null;
    if (w && !done.formStart) {
      done.formStart = 1;
      send('vip_form_start', { form_location: formLocation(w) });
    }
  });

  // Secoes vistas (metade da secao na tela)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = en.target.getAttribute('data-zv-sec');
        io.unobserve(en.target);
        if (n && !done['v' + n]) { done['v' + n] = 1; send('section_view', { section: n }); }
      });
    }, { threshold: 0.35 });
    [['.zv-hero', 'hero'], ['#filmes', 'filmes'], ['#sobre', 'sobre'], ['#lista-vip', 'lista_vip']].forEach(function (t) {
      var node = document.querySelector(t[0]);
      if (node) { node.setAttribute('data-zv-sec', t[1]); io.observe(node); }
    });
  }

  // Profundidade de rolagem: 25, 50, 75 e 100%
  var scroller = document.querySelector('.page-wrapper');
  function depth() {
    var useWrap = scroller && scroller.scrollHeight > scroller.clientHeight + 4;
    var top = useWrap ? scroller.scrollTop : (window.scrollY || 0);
    var view = useWrap ? scroller.clientHeight : window.innerHeight;
    var total = useWrap ? scroller.scrollHeight : document.documentElement.scrollHeight;
    return total ? Math.min(100, Math.round((top + view) / total * 100)) : 0;
  }
  function checkDepth() {
    var d = depth();
    [25, 50, 75, 100].forEach(function (m) {
      if (d >= m && !done['s' + m]) { done['s' + m] = 1; send('scroll_depth', { percent: m }); }
    });
  }
  if (scroller) scroller.addEventListener('scroll', checkDepth, { passive: true });
  window.addEventListener('scroll', checkDepth, { passive: true });
})();
